<template>
  <v-checkbox v-model="profile.receiveDigests"
              label="I would like to receive weekly emails"
              @change="submit" :color="themes.candidate.light.input">
  </v-checkbox>
</template>

<script>
// Vue Component
export default {
  props: ['value'],
  data() {
    return {
      // Model (object sent to API)
      profile: {
        receiveDigests: this.value
      }
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('candidate/profile/update', this.profile)
    }
  }
}
</script>
